<div class="context__actions">
	<div class="container">
		<div class="app-context-menu__left">
			<button class="back-button" (click)="INDRA_handleBackButton()" [attr.aria-label]="'contextMenu.aria.goBackPrevious' | ibeadmin | async" *ngIf="isBack">
				<app-svg svg="icons.svg#general--arrow--left" aria-hidden="true" [alt]="'Arrow left icon'"></app-svg>
			</button>
			<h1 class="title">
				<span skeletonLoader [translationKey]="'contextMenu.text.' + contextMenuTitle">
					{{contextMenuStep}}
					{{'contextMenu.text.' + contextMenuTitle | ibeadmin | async}}
				</span>
			</h1>
		</div>
		<div class="actions-container" *ngIf="!INDRA_hiddeEdit()">
			<button class="actions-button" (click)="INDRA_handleActionsButton()">
				<app-svg svg="icons.svg#general--edit" aria-hidden="true" [alt]="'Edit icon'"></app-svg>
			</button>
			<ng-content select=".actions"></ng-content>
		</div>
	</div>
</div>
<div class="context__steps" *ngIf="!INDRA_hideSteps()">
	<div class="full-width">
		<ng-content select=".steps" aria-label="List with steps" tabindex=0></ng-content>
	</div>
</div>
<ng-content select=".extra"></ng-content>
